import React, {Component} from "react"
import Meta from "../Meta"
import Header from "../header"
import Footer from "../footer"
import EncheresSpace from "../../../components/EncheresSpace"
import {metaEnchere} from "../../../components/EncheresSpace/meta"

// Wrapper Ummah : habille la page d'enchères avec le Header/Footer du site.
// Le composant lui-même reste agnostique du thème.
export default class EncheresPage extends Component {
    render() {
        const context = this.props.context
        // Titre, description et image de partage de LA vente affichée : réglés
        // par le responsable, lus au rendu serveur — c'est ce que voit le
        // groupe WhatsApp où l'on colle le lien.
        const meta = metaEnchere(context)
        return (
            <div>
                <Meta context={context} title={meta.title} description={meta.description} image={meta.image}/>
                <Header context={context}/>
                <div style={{minHeight: "70vh", marginTop: 32}}>
                    <EncheresSpace context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
